import CertificateBatchList from "./CertificateBatchList";

export default CertificateBatchList;
